import { TinkLinkUrlParameter } from '@tink/config/src/TinkLinkUrlParameter';
import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { RefreshableItem } from '../models/refreshableItem';
import { ValidateProductParams } from '../utilities/urlParameters';

export const validateParams: ValidateProductParams = (commonParams, getRawParam) => {
  const errors = [];
  const parameters = commonParams;
  parameters.scope = 'accounts:read,identity:read';

  const consentId = getRawParam(TinkLinkUrlParameter.CONSENT_ID);
  const bulkPaymentRequestId = getRawParam(TinkLinkUrlParameter.BULK_PAYMENT_REQUEST_ID);
  const paymentRequestId = getRawParam(TinkLinkUrlParameter.PAYMENT_REQUEST_ID);

  // This transfer id is present in url when user authenticated (PIS) on 3rd party
  // provider page and is redirected back to Tink Link.
  const transferId = getRawParam(TinkLinkUrlParameter.TRANSFER_ID);

  if (!paymentRequestId) {
    errors.push({
      errorStatus: ErrorStatus.BAD_REQUEST,
      errorReason: ErrorReason.INVALID_PARAMETER_PAYMENT_REQUEST_ID,
    });
  }

  return {
    parameters: {
      refreshableItems: [RefreshableItem.IDENTITY_DATA, RefreshableItem.CHECKING_ACCOUNTS],
      consentId,
      paymentRequestId,
      transferId,
      bulkPaymentRequestId,
    },
    errors,
  };
};
